var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-navigation"},[(_vm.is_mobile())?_c('custom-logo',{staticClass:"panel-navigation__logo"}):_vm._e(),_c('availability',{staticClass:"panel-navigation__user",attrs:{"name":_vm.name}}),_c('navigation',{staticClass:"panel-navigation__menu"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }